import { DrinkVariant } from '@/config/drinkVariants';

interface ProductSectionProps {
  currentVariant: DrinkVariant;
}

const ProductSection = ({ currentVariant }: ProductSectionProps) => {
  return (
    <section id="product" className="py-24 md:py-32 bg-card relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative order-2 md:order-1">
            <div className="relative aspect-square max-w-md mx-auto">
              <img
                src={currentVariant.productImage}
                alt={`${currentVariant.name} ${currentVariant.subtitle} can surrounded by fresh ingredients`}
                className="w-full h-full object-contain drop-shadow-2xl"
              />
              {/* Glow effect */}
              <div className="absolute inset-0 bg-primary/20 blur-3xl -z-10 scale-75" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <span className="text-xs font-medium tracking-[0.3em] text-primary uppercase mb-4 block">
              About The Drink
            </span>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-foreground mb-6">
              Bold Flavor,<br />
              <span className="text-primary">Pure Refresh</span>
            </h2>
            <p className="text-muted-foreground mb-8 leading-relaxed text-lg">
              {currentVariant.description}
            </p>
            <p className="text-muted-foreground mb-8 leading-relaxed">
              Distributed by DLC, a trusted name in premium food distribution, G represents our commitment to quality, innovation, and bold taste experiences.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <span className="font-display text-4xl text-primary">{currentVariant.productStats.stat1Value}</span>
                <p className="text-sm text-muted-foreground mt-1">{currentVariant.productStats.stat1Label}</p>
              </div>
              <div>
                <span className="font-display text-4xl text-primary">{currentVariant.productStats.stat2Value}</span>
                <p className="text-sm text-muted-foreground mt-1">{currentVariant.productStats.stat2Label}</p>
              </div>
              <div>
                <span className="font-display text-4xl text-primary">{currentVariant.productStats.stat3Value}</span>
                <p className="text-sm text-muted-foreground mt-1">{currentVariant.productStats.stat3Label}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
